import React from 'react';

import { LazyMacroUsagePage } from '@confluence/site-settings/entry-points/MacroUsagePage.ts';
import { ADMIN_MACRO_USAGE_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/macroUsageConstants.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminMacroUsageRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <LazyMacroUsagePage />;

AdminMacroUsageRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: ADMIN_MACRO_USAGE_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
